import { Box, Button, TextField } from "@mui/material";
import { Modal } from "components/Modal";
import { FC, useState } from "react";
import { sendAlertViaEmail } from "../../reduxStore/alert/thunks";
import { ALERT_TYPES } from "../../helpers/constants";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";
import { userSelector } from "../../reduxStore/auth/selectors";

type BugReportAndSuggestionsModalProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: (report: string) => void;
};

export const BugReportAndSuggestionsModal: FC<
  BugReportAndSuggestionsModalProps
> = ({ open, onClose, onSubmit }) => {
  const [reportText, setReportText] = useState("");
  const dispatchRedux = useAppDispatch();
  const user = useAppSelector(userSelector);

  const handleSend = () => {
    dispatchRedux(
      sendAlertViaEmail({
        type: ALERT_TYPES.BUG_REPORT_SUGGESTION_RECEIVED,
        text: reportText,
        userName: user?.name || "unknown",
        userEmail: user?.email || "unknown",
      }),
    );
    onSubmit(reportText);
    setReportText(""); // Clear the text area after submission
    onClose(); // Close the modal
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Submit a Bug Report or Suggestion"
      size="medium"
    >
      <Box sx={{ p: 2 }}>
        <TextField
          label="Your report or suggestion"
          multiline
          rows={6}
          fullWidth
          variant="outlined"
          value={reportText}
          onChange={(e) => setReportText(e.target.value)}
        />
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button
            variant="contained"
            onClick={handleSend}
            disabled={reportText.trim() === ""}
          >
            Send
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
